import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/icons/logo-2.svg'


const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"row border-top border-bottom my-3 align-items-center\"><div class=\"col my-3 text-center\"><img style=\"height:50px;width:161px;\" src=\"" + _imports_0 + "\"></div></div><div class=\"border-bottom\"><div class=\"mb-4\"><strong>Behöver du renovera din bostad efter tillträdet men saknar finansiering?</strong> Vi kan hjälpa dig med renoveringslånet. Vi jobbar med långivare som har marknadens lägsta räntor på privatlån. Du kan helt kostnadsfritt och med endast en kreditupplysning jämföra upp till 20 långivare för att hitta renoveringslånet som passar dig. Du kan ansöka om lån mellan 10 000 och 600 000 kr med återbetalningstid på mellan 1 och 20 år. </div></div>", 2)
const _hoisted_3 = {
  key: 0,
  class: "row my-5"
}
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "row mt-3 text-center fs-3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Vanliga frågor om privatlån")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExpandPanel = _resolveComponent("ExpandPanel")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (_ctx.isPaid)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToPage())),
              class: "btn btn-primary"
            }, " Till ansökan ")
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_5,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.qaItems, (qa) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "row my-3",
        key: qa.index
      }, [
        _createVNode(_component_ExpandPanel, { item: qa }, null, 8, ["item"])
      ]))
    }), 128))
  ]))
}